import styled from "styled-components";

const Container = styled.div`
  padding: 10px;
  min-height: calc(100vh - var(--header-height));
`;

export default Container;
